import { createAction, RSAAAction } from 'redux-api-middleware'

import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'

interface ActionsTypes {
    [actionType: string]: string
}

const Types: ActionsTypes = {
    DEVICE_BYPASS_AUTH_REQUEST: 'DEVICE_BYPASS_AUTH##REQUEST',
    DEVICE_BYPASS_AUTH_SUCCESS: 'DEVICE_BYPASS_AUTH##SUCCESS',
    DEVICE_BYPASS_AUTH_FAILURE: 'DEVICE_BYPASS_AUTH##FAILURE',
}

/**
 * Bypass device Auth
 * @param deviceId Device ID
 */
function bypassDeviceAuth(deviceId: string): RSAAAction {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices/noauth/${deviceId}`,
        method: 'POST',
        types: [Types.DEVICE_BYPASS_AUTH_REQUEST, Types.DEVICE_BYPASS_AUTH_SUCCESS, Types.DEVICE_BYPASS_AUTH_FAILURE],
    })
}

export { Types, bypassDeviceAuth }
